import { Select } from "../survey";

/**
 * Checks for empty or whitespace-only values in Select choices.
 */
export const noEmptySelectValuesRule = (select: Readonly<Select>) => {
  for (const option of select.choices) {
    if (!option.value || option.value.trim() === '') {
      return {
        passed: false,
        message: `Empty Select value for target field "${select.targetField}"`
      };
    }
  }
  return { passed: true };
}
